export const propertyTypeOptions = [
    { id: 1, label: "House" },
    { id: 2, label: "Bungalow" },
    { id: 3, label: "Flat" },
    { id: 4, label: "Maisonette" },
    { id: 5, label: "Cottage" },
    { id: 6, label: "Farm" },
    { id: 7, label: "Development Plot" },
    { id: 8, label: "Apartment" },
];

export const minPriceOptions = [
    { id: 10000, label: "£10,000" },
    { id: 20000, label: "£20,000" },
    { id: 30000, label: "£30,000" },
    { id: 40000, label: "£40,000" },
    { id: 50000, label: "£50,000" },
    { id: 100000, label: "£100,000" },
    { id: 200000, label: "£200,000" },
    { id: 300000, label: "£300,000" },
    { id: 400000, label: "£400,000" },
    { id: 500000, label: "£500,000" },
    { id: 600000, label: "£600,000" },
    { id: 700000, label: "£700,000" },
    { id: 800000, label: "£800,000" },
    { id: 900000, label: "£900,000" },
    { id: 1000000, label: "£1,000,000" },
    { id: 1100000, label: "£1,100,000" },
    { id: 1200000, label: "£1,200,000" },
    { id: 1300000, label: "£1,300,000" },
    { id: 1400000, label: "£1,400,000" },
    { id: 1500000, label: "£1,500,000" },
    { id: 2000000, label: "£2,000,000" },
    { id: 3000000, label: "£3,000,000" },
    { id: 4000000, label: "£4,000,000" },
];

export const maxPriceOptions = [
        { id: 400, label: '£400 PCM' },
        { id: 450, label: '£450 PCM' },
        { id: 500, label: '£500 PCM' },
        { id: 550, label: '£550 PCM' },
        { id: 600, label: '£600 PCM' },
        { id: 650, label: '£650 PCM' },
        { id: 700, label: '£700 PCM' },
        { id: 750, label: '£750 PCM' },
        { id: 800, label: '£800 PCM' },
        { id: 850, label: '£850 PCM' },
        { id: 900, label: '£900 PCM' },
        { id: 950, label: '£950 PCM' },
        { id: 1000, label: '£1,000 PCM' },
        { id: 1100, label: '£1,100 PCM' },
        { id: 1200, label: '£1,200 PCM' },
        { id: 1300, label: '£1,300 PCM' },
        { id: 1400, label: '£1,400 PCM' },
        { id: 1500, label: '£1,500 PCM' },
        { id: 1600, label: '£1,600 PCM' },
        { id: 1700, label: '£1,700 PCM' },
        { id: 1800, label: '£1,800 PCM' },
        { id: 1900, label: '£1,900 PCM' },
        { id: 2000, label: '£2,000 PCM' },
        { id: 2250, label: '£2,250 PCM' },
        { id: 2500, label: '£2,500 PCM' },
        { id: 2750, label: '£2,750 PCM' },
        { id: 3000, label: '£3,000 PCM' },
        { id: 3250, label: '£3,250 PCM' },
        { id: 3500, label: '£3,500 PCM' },
        { id: 3750, label: '£3,750 PCM' },
        { id: 4000, label: '£4,000 PCM' },
        { id: 4250, label: '£4,250 PCM' },
        { id: 4500, label: '£4,500 PCM' },
        { id: 4750, label: '£4,750 PCM' },
        { id: 5000, label: '£5,000 PCM' },
        { id: 5250, label: '£5,250 PCM' },
        { id: 5500, label: '£5,500 PCM' },
        { id: 5750, label: '£5,750 PCM' },
        { id: 6000, label: '£6,000 PCM' },
    ];

    export const distanceOptions = [
            { id: 1, label: "1/4 mile" },
            { id: 2, label: "1/2 mile" },
            { id: 3, label: "1 mile" },
            { id: 4, label: "25 miles" },
        ];

        export const BedOptions= [
                { id: 1, label: "1 Bed" },
                { id: 2, label: "2 Beds" },
                { id: 3, label: "3 Beds" },
                { id: 4, label: "4 Beds" },
                { id: 5, label: "5 Beds" },
                { id: 6, label: "6 Beds" },
                { id: 7, label: "7 Beds" },
                { id: 8, label: "8 Beds" },
            ];

            export const StatusOptions = [
                { id: 1, label: "For Sale" },
                { id: 2, label: "For Rent" },
                { id: 3, label: "Sold" },
                { id: 4, label: "SSTC" },
                { id: 5, label: "Let Out" },
            ]